import { SingleLayoutDetails } from '@/types/pages/storeManagement/device';
import {
    ASSOCIATE_PAIRING_MODE,
    AssociateModeRelations,
    IdentifierInfo,
    ImageInfo,
    ShelfInfo,
} from '@/types/pages/storeManagement/device/associate';

export const INITIAL_SHELF_INFO: ShelfInfo = {
    openFeature: false,
    shouldOpenDialog: false,
    options: [],
    relations: {},
};

export const INITIAL_IMAGE_INFO: ImageInfo = {
    openFeature: false,
    options: [],
    relations: {},
};

export type AssociationViewState = {
    product: string;
    singleLayoutInfo: SingleLayoutDetails[];
    defaultLayoutId: number | null;
    selectedPairingMode: ASSOCIATE_PAIRING_MODE;
    showImageMode: boolean;
    planogramConfig: { enable: boolean; noOption: boolean; autoSelect: boolean };
    campaignEnable: boolean;
    layoutDialogOpen: boolean;
    planogramDialogOpen: boolean;
    imageDialogOpen: boolean;
    isProductInputEnabled: boolean;
    isSubmitting: boolean;
    shelfInfo: ShelfInfo;
    imageInfo: ImageInfo;
    identifierInfo: IdentifierInfo | null;
    pendingAssociationContext: AssociationFlowContext | null;
};

export type AssociationViewAction = { type: 'PATCH'; payload: Partial<AssociationViewState> } | { type: 'RESET_ALL' };
export type AssociationFlowContext = {
    mac: string;
    productBarcode: string;
    relations?: AssociateModeRelations;
};

export const defaultState: AssociationViewState = {
    product: '',
    singleLayoutInfo: [],
    defaultLayoutId: null,
    selectedPairingMode: ASSOCIATE_PAIRING_MODE.NORMAL,
    showImageMode: false,
    planogramConfig: { enable: false, noOption: false, autoSelect: false },
    campaignEnable: false,
    layoutDialogOpen: false,
    planogramDialogOpen: false,
    imageDialogOpen: false,
    isProductInputEnabled: false,
    isSubmitting: false,
    shelfInfo: INITIAL_SHELF_INFO,
    imageInfo: INITIAL_IMAGE_INFO,
    identifierInfo: null,
    pendingAssociationContext: null,
};

export const reducer = (state: AssociationViewState, action: AssociationViewAction): AssociationViewState => {
    switch (action.type) {
        case 'PATCH':
            return {
                ...state,
                ...action.payload,
            };
        case 'RESET_ALL':
            return defaultState;
        default:
            return state;
    }
};

export class AssociationError extends Error {
    code?: string;
    status?: number;
    historyData?: {
        mac: string;
        productBarcode: string;
        productName: string;
    };

    constructor(
        message: string,
        options?: {
            code?: string;
            status?: number;
            historyData?: {
                mac: string;
                productBarcode: string;
                productName: string;
            };
        },
    ) {
        super(message);
        this.name = 'AssociationError';
        this.code = options?.code || '';
        this.status = options?.status;
        this.historyData = options?.historyData;
    }
}
